
import { useParams } from 'react-router-dom';
import { InventariosCabFormState } from '../../../context/inventariosCab//InventariosCabFormState';
import { Form } from './form';

export const InventariosCabFormPage = () => {
  const { id } = useParams();
  const title = id ? "Ver Inventario":"Crear Inventario";

  return (
    <InventariosCabFormState>
         <br />
        <Form title={title} />
    </InventariosCabFormState>
  );
};
